import uniqBy from 'lodash/uniqBy';

import type { ActivityItemEdge } from '@atlassian/search-client/recent-activities/types';

import type { QuickFindResult } from '../../../../common/ui/quick-find/types.tsx';

/**
 * Deduplicates arrays of items by id, keeping the first occurrence of each unique id
 * and sorts them by timestamp (most recent first)
 */
export const dedupAndSortRecentActivities: <T extends QuickFindResult<ActivityItemEdge>>(
	existingItems: T[],
	newItems: T[],
) => T[] = <T extends QuickFindResult<ActivityItemEdge>>(existingItems: T[], newItems: T[]) => {
	const deduplicatedResults = uniqBy([...existingItems, ...newItems], (item) => item.id);

	// We sort to show the most recent autorefreshed results in pre-query state.
	try {
		deduplicatedResults.sort(
			(a, b) =>
				new Date(b.data.node.event.timestamp).getTime() -
				new Date(a.data.node.event.timestamp).getTime(),
		);
	} catch {
		// If we have an error, the results simply won't be sorted.
	}

	return deduplicatedResults;
};
